import { z } from 'zod';

import { UuidSchema } from '@repo/validation';
const validateNotPastDate = (val: string | null | undefined) => {
  if (!val) return true;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(val)) return false;
  const dateVal = new Date(val);
  if (isNaN(dateVal.getTime())) return false;
  const today = new Date();
  const currentYear = today.getFullYear();
  const year = dateVal.getFullYear();
  if (year < currentYear - 1 || year > currentYear + 10) return false;
  today.setHours(0, 0, 0, 0);
  dateVal.setHours(0, 0, 0, 0);
  return dateVal >= today;
};

export const CreateContactSchema = z.object({
  fullName: z.string().min(2, 'Name must be at least 2 characters'),
  mobile: z.string().regex(/^[6-9]\d{9}$/, 'Invalid Indian mobile number'),
  mobileAlt: z.string().regex(/^[6-9]\d{9}$/, 'Invalid Indian mobile number').optional().nullable(),
  locality: z.string().optional().nullable(),
  email: z.string().email('Invalid email address').optional().nullable(),
  addressLine1: z.string().optional().nullable(),
  addressLine2: z.string().optional().nullable(),
  city: z.string().optional().nullable(),
  stateCode: z.string().optional().nullable(),
  pincode: z.string().regex(/^\d{6}$/, 'Pincode must be 6 digits').optional().nullable(),
  occupation: z.string().optional().nullable(),
  monthlyIncome: z.number().min(0).optional().nullable(),
  source: z.enum(['WALK_IN', 'REFERRAL', 'CAMP', 'AGENT_REFERRAL', 'DIGITAL', 'OTHER']),
  referralContactId: UuidSchema.optional().nullable(),
  referralCustomerId: UuidSchema.optional().nullable(),
  notes: z.string().optional().nullable(),
  followUpDate: z.string().refine(validateNotPastDate, { message: 'Follow-up date cannot be in the past' }).optional().nullable(),
  assignedTo: UuidSchema.optional().nullable(),
});

export const UpdateContactSchema = CreateContactSchema.partial();

export const CreateActivitySchema = z.object({
  activityType: z.enum(['CALL', 'VISIT', 'MESSAGE', 'NOTE', 'STAGE_CHANGE', 'FOLLOW_UP_SET']),
  performedAt: z.string().optional().nullable(),
  outcome: z.enum(['REACHED', 'NOT_REACHED', 'INTERESTED', 'NOT_INTERESTED', 'CALLBACK_LATER']).optional().nullable(),
  notes: z.string().optional().nullable(),
  followUpDate: z.string().refine(validateNotPastDate, { message: 'Follow-up date cannot be in the past' }).optional().nullable(),
});

export const PromoteContactSchema = z.object({
  targetStage: z.enum(['LEAD']),
  notes: z.string().optional().nullable(),
});

export const LoseContactSchema = z.object({
  reason: z.string().min(10, 'Reason must be at least 10 characters'),
});
